import axios from 'axios';
import { ADMIN_API_ORIGIN } from '@/config/domains';
import { API_TIMEOUT } from '@/utils/constants';

// API host/path - 常量配置
export const API_HOST = ADMIN_API_ORIGIN;
export const API_BASE_PATH = '/api';
export const API_BASE_URL = `${API_HOST}${API_BASE_PATH}/`;

const api = axios.create({
  baseURL: `${API_BASE_URL}admin/`,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // 支持 cookie
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 可以在这里添加 token 等认证信息
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 统一错误处理
    if (error.response) {
      // 服务器返回了错误状态码
      const { status, data } = error.response;
      console.error(`API Error: ${status}`, data);

      // 可以根据状态码进行不同的处理
      switch (status) {
        case 401:
          // 未授权，设置认证状态为 false，ProtectedRoute 会自动弹出登录弹窗
          import('@/stores/authStore').then(({ authStore }) => {
            authStore.setUser(null);
          });
          break;
        case 403:
          // 禁止访问
          break;
        case 404:
          // 资源不存在
          break;
        case 500:
          // 服务器错误
          break;
        default:
          break;
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      console.error('Network Error', error.request);
    } else {
      // 其他错误
      console.error('Error', error.message);
    }

    return Promise.reject(error);
  },
);

export default api;
